import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { push } from "connected-react-router";

import { faPlusCircle } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Row, Col, Tooltip } from "antd";
import navigationActions from "../../../common/components/navigation/action";
import TeamGrid from "../team-grid";
import actions from "../actions";
import "./TeamPages.scss";

class TeamIndexPage extends React.Component {
  componentDidMount() {
    this.props.dispatch(navigationActions.changePage("team"));
    this.props.dispatch(actions.GetGridList());
  }

  handleAddClick = () => {
    this.props.dispatch(push("/team/create"))
  };

  render() {
    return (
      <div className="p5-page-container">
        <Row justify="center">
          <Col xs={24} md={20} lg={18}>
            <span>
              <h1 className="p5-page-h1-header">
                Teams
                <Tooltip title="Add Team">
                  <FontAwesomeIcon
                    icon={faPlusCircle}
                    id="TeamAdd"
                    className="team-add-icon"
                    alt="teamAddIcon"
                    onClick={() => this.handleAddClick()}
                    pull="right"
                    size="1x"
                  />
                </Tooltip>
              </h1>
            </span>
          </Col>
        </Row>
        <Row justify="center">
          <Col xs={24} md={20} lg={18}>
            <TeamGrid />
          </Col>
        </Row>
      </div>
    );
  }
}

TeamIndexPage.propTypes = {
  dispatch: PropTypes.func,
};

TeamIndexPage.defaultProps = {
  dispatch: () => {},
};

function mapStateToProps() {
  return {};
}

const connectedIndexPage = connect(mapStateToProps)(TeamIndexPage);

export { connectedIndexPage as default };
